export default {
  addMember: 'Add new member',
  contractTitle: '{{packageTypeName}} - Select Contracts',
  contractorJoiningScheduled: 'Joining Scheduled',
  draftOnly: 'Draft only',
  emptyWithAction: "Can't find any workers?",
  error: 'An error occurred',
  errorDescription: 'An error occurred while fetching data.',
  hasFamily: 'Has family',
  joiningScheduled: 'Joining Scheduled',
  leaveKindFilter: {
    CHILDCARE_LEAVE: 'Childcare leave',
    MATERNITY_LEAVE: 'Maternity leave',
    NURSING_CARE_LEAVE: 'Nursing care leave',
    OTHER: 'Other leave',
    SICK_LEAVE: 'Sick leave',
    label: 'Leave type'
  },
  missingPackageInfo: 'Package information not found',
  missingPackageInfoDescription: 'Please select a package before accessing this page.',
  nextStep: 'Next',
  notSupported: 'This feature is not supported',
  notSupportedDescription: 'The target selection feature is not available for the selected package type.',
  searchContractPlaceholder: 'Search by contractor name',
  searchPlaceholder: 'Search by name or email',
  selectedContractCount: '{{count}} contracts selected',
  selectedCount: '{{count}} selected',
  title: '{{packageTypeName}} - Select Targets'
};